import { Component, Input } from "@angular/core";
import { PhoneBookData } from "src/app/meta/PhoneBookData.interface";

@Component({
    selector: "ow-order-summary-phone-book",
    templateUrl: "./order-summary-phone-book.component.html"
})
export class OrderSummaryPhoneBookComponent {

    @Input() phoneBookData!: PhoneBookData

}
